import React from 'react';
import { useActionListContext } from '../../context';
import { ActionListDividerProps } from './index.types';

const ActionListDivider = ({
  testID: customTestID,
  ...props
}: ActionListDividerProps) => {
  const context = useActionListContext();
  const baseTestID = customTestID || context?.testID;
  const componentTestId = baseTestID ? `${baseTestID}-action-list-divider` : 'action-list-divider';

  return (
    <div
      className="border-t border-border my-1 w-full"
      role="separator"
      aria-orientation="horizontal"
      data-testid={componentTestId}
      {...props}
    />
  );
};

export default ActionListDivider;
